<script setup lang="ts">
const { t } = useI18n()

const thumbnails = [
  '/projects/kaenbio-site.webp',
  '/projects/la-voie-de-lhuitre.webp',
  '/projects/laura-colibri.webp',
]
</script>

<template>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
    <!-- primary: slide to answer -->
    <NuxtLinkLocale
      to="/contact"
      class="slide relative flex h-14 items-center rounded-full bg-white pl-16 pr-7 font-medium"
    >
      <span class="slide-label">{{ t("agency.cta") }}</span>
      <span class="slide-knob absolute left-2 top-2 flex size-10 items-center justify-center rounded-full bg-neutral-950 text-white">
        <UIcon
          name="heroicons:arrow-right"
          class="size-4"
        />
      </span>
    </NuxtLinkLocale>

    <!-- secondary: a preview of the work behind the link -->
    <NuxtLinkLocale
      to="/works"
      class="group flex h-14 items-center justify-between gap-4 rounded-full border border-white/15 bg-white/5 pl-3 pr-6 font-medium text-white backdrop-blur-sm transition-colors duration-200 hover:border-white/30 hover:bg-white/10"
    >
      <span
        aria-hidden="true"
        class="flex -space-x-3 transition-all duration-300 group-hover:-space-x-1.5"
      >
        <NuxtImg
          v-for="thumbnail in thumbnails"
          :key="thumbnail"
          :src="thumbnail"
          width="80"
          height="80"
          alt=""
          class="size-9 rounded-full border-2 border-neutral-900 object-cover"
        />
      </span>
      {{ t("global.see_projects") }}
    </NuxtLinkLocale>
  </div>
</template>

<style scoped>
  .slide-label {
    color: rgb(10 10 10);
    transition:
      color 200ms ease,
      transform 500ms cubic-bezier(0.65, 0, 0.35, 1);
  }

  .slide-knob {
    transition: left 500ms cubic-bezier(0.65, 0, 0.35, 1);
  }

  /* one movement: the knob glides to the far end while the text makes room */
  .slide:hover .slide-knob,
  .slide:focus-visible .slide-knob,
  .slide:active .slide-knob {
    left: calc(100% - 3rem);
  }

  .slide:hover .slide-label,
  .slide:focus-visible .slide-label,
  .slide:active .slide-label {
    background: none;
    color: rgb(10 10 10);
    transform: translateX(-2.25rem);
    animation: none;
  }

  /* at rest, only the light sweeping over the text */
  @media (prefers-reduced-motion: no-preference) {
    .slide-label {
      background: linear-gradient(100deg, rgb(10 10 10 / 0.6) 40%, rgb(10 10 10) 50%, rgb(10 10 10 / 0.6) 60%) 100% 0 / 300% 100%;
      background-clip: text;
      color: transparent;
      animation: slide-shimmer 3.5s linear infinite;
    }
  }

  @keyframes slide-shimmer {
    to {
      background-position: 0% 0;
    }
  }
</style>
